import { IDashboardContext } from "Interfaces/Providers/Dashboard";
import { DashboardContext } from "providers/Schedule/DashboardProvider";
import { useContext } from "react";

export default function useDashboard(): IDashboardContext {
  const context = useContext(DashboardContext);

  return context;
}
